/* global process */
/* eslint-disable no-process-env */
import {getMetaContentByName} from "util/env"
import * as Sentry from "@sentry/react"
import {BrowserTracing} from "@sentry/tracing"
import {isStaging} from "./util/env"

import {createBrowserHistory} from "history"
const cdnUrl = getMetaContentByName("cdn-url")

const dsn = getMetaContentByName("sentry-dsn")
if (dsn && typeof Sentry !== "undefined") {
  const history = createBrowserHistory()
  Sentry.init({
    dsn: dsn,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
      })
    ],
    environment: isStaging() ? "staging-web" : "production",
    tracesSampleRate: 0.1,
    allowUrls: [/banzai\.org\//i, /banzai-staging\.org\//i, /teachbanzai\.com\//i, /learnbanzai\.com\//i, /platform-app-staging\.herokuapp\.com\//i],
    ignoreErrors: [
      "ReferenceError: Can't find variable: mobiGetClick",
      /Can't find variable: __gCrWeb/,
      /undefined is not an object (evaluating '__gCrWeb.autofill.extractForms')/,
      /Access is denied/,
      /Permission denied/,
      /ztePageScrollModule/,
      /window\.HtmlViewer\.showHTML is not a function/,
      /ResizeObserver loop limit exceeded/,
      /TypeError: Failed to fetch/,
      /TypeError: Load failed/,
      /ChunkLoadError/
    ]
  })
}
